<template>
	<fieldset class="coderate_fieldset">
		<legend>{{ language.rateCodeLegend }}</legend>
		<input type="hidden" name="promo" id="promo" :value="codeToSend">
		<div class="form-row form-row--wide has_subnav" v-bind:class="{active: dropDownOpen}" v-click-outside="hideDropdown" @keydown=keyDownHandler>
			<div class="form-field">
				<label for="coderate_display">{{ this.$store.state.language.ratesCodes }}</label>
				<input name="coderate_display" id="coderate_display" ref="coderateDisplay" :value="rateToShow" readonly @click="openDropdown" @keydown.enter.prevent="toggleDropdown" @keydown.space="openDropdown" @keyup.escape="hideDropdown" @focus="onFocus" :class="{'focus': dropDownOpen}">

				<div :class="dropDownOpen ? 'input-dropdown open' : 'input-dropdown'" v-if="dropDownOpen" ref="coderateDropdown">
					<div class="input-dropdown__segment" v-if="visibleRates.length > 0">
						<header>
							{{ language.ratesOfferings }}
						</header>
						<ul>
							<li v-for="currentRate in visibleRates" :key="currentRate.code">
								<a href="#" v-html="currentRate.name" v-bind:class="{active: !usePromo && currentRate.code == rate.code}" @click.prevent="selectRate(currentRate)" v-if="!currentRate.inactive"></a>
								<a v-html="currentRate.name" class="inactive" v-if="currentRate.inactive"></a>
							</li>
						</ul>
					</div>
					<div class="input-dropdown__segment">
						<header>
							{{ language.promoCode }}
						</header>
						<div class="form-row form-row--wide" v-bind:class="{cancellable: (isCancellable && usePromo), activated: usePromo}">
							<div class="form-field">
								<label for="corporatecode" class="hidden">{{ language.promoCode }}</label>
								<input type="text" id="corporatecode" name="corporatecode" v-model="promo" :placeholder="language.promoCodePH" autocomplete="off" class="input--border" @focusin="selectPromoText" ref="promo" @keydown.enter.prevent="hideDropdown">
							</div>
							<div class="cancelButton" v-if="isCancellable && usePromo" @click="clearSelection"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
	name: 'RateCode',

	data: function(){
		return {
			dropDownOpen: false,
			timeout: null,
			delay: 522,
		}
	},

	mounted: function (){
		this.$store.commit('setRate', this.getDefaultRate())
	},

	computed: {
		language: function () {
			return this.$store.state.language
		},

		isCancellable: function(){
			return this.usePromo || false
		},

		usePromo: {
			set(val){
				return val
			},
			get(){
				return !!this.$store.state.promo || false
			}
		},

		rateToShow: {
			set() {
				// console.log(value)
			},
			get(){
				if(this.usePromo) {
					return this.promo
				}
				else {
					return this.rate.name
				}
			}
		},

		codeToSend: function(){
			if(this.usePromo) {
				return this.promo
			}
			else {
				return this.rate.code
			}
		},

		defaultRate: function () {
			return this.$store.state.defaultRate
		},

		rates: function () {
			return this.$store.state.rates
		},

		rate: function () {
			if (!this.$store.state.rate) {
				return this.getDefaultRate()
			}
			return this.$store.state.rate
		},

		promo: {
			get() {
				return this.$store.state.promo
			},
			set(value) {
				const that = this
				if(this.timeout) clearTimeout(this.timeout)
				this.timeout = setTimeout(function(){
					that.$store.dispatch('addPromo', {promo: value})
				}, this.delay)
			}
		},

		visibleRates: function () {
			return this.rates.filter(rate => !rate.invisible)
		}
	},

	methods: {

		getDefaultRate() {
			const defaultRate = this.$store.state.defaultRate
			let defaultRates = this.$store.state.rates.filter(rate => rate.code == defaultRate)
			return defaultRates.shift()
		},

		toggleDropdown() {
			if(this.dropDownOpen) return this.hideDropdown()
			return this.openDropdown()
		},

		onFocus() {
			this.$emit('focus')
		},

		openDropdown() {
			this.dropDownOpen = true
			this.$emit('opened')
		},

		hideDropdown() {
			this.dropDownOpen = false
			this.$emit('closed')
		},

		selectRate(rate) {
			this.dropDownOpen = false
			this.usePromo = false
			this.promo = ''
			this.$store.dispatch('chooseRate', {rate: rate})
		},

		selectPromoText(){
			this.$refs.promo.select()
		},

		clearSelection() {
			this.$store.dispatch('chooseRate')
			this.$store.dispatch('addPromo')
			this.$nextTick(function (){
				this.isCancellable = false
				this.usePromo = false
			})
		},

		keyDownHandler(e){
			if(e.key == 'Tab'){
				this.hideDropdown();
			}
			else if(e.key == 'Escape'){
				this.$refs.coderateDisplay.focus()
			}
			else {
				if(e.key == 'ArrowDown'){
					// next
					this.focusNextItem(e)
				}
				if(e.key == 'ArrowUp'){
					// prev
					this.focusPrevItem(e)
				}
			}
		},

		focusNextItem(e){
			const eventTarget = e.target;
			let nextItem = eventTarget.parentNode.nextElementSibling;

			// When key down happens in initial input field
			if(e.target === this.$refs.coderateDisplay){
				this.openDropdown()
				nextItem = this.$refs.coderateDropdown;
			}
			else if(!nextItem) {
				nextItem = eventTarget.parentNode.parentNode.parentNode.nextElementSibling || eventTarget.parentNode.parentNode.parentNode.previousElementSibling;
			}

			// Select first a in nextItem
			if(nextItem) nextItem.querySelector('a,input').focus();
			e.preventDefault();
		},

		focusPrevItem(e){
			// When key down happens in initial input field do nothing
			if(e.target === this.$refs.coderateDisplay) return;

			const eventTarget = e.target;
			let nextItem = eventTarget.parentNode.previousElementSibling;

			if(!nextItem) {
				nextItem = eventTarget.parentNode.parentNode.parentNode.previousElementSibling || eventTarget.parentNode.parentNode.parentNode.nextElementSibling;
			}

			// Select first a in nextItem
			if(nextItem) nextItem.querySelector('a,input').focus();
			e.preventDefault();
		},
	},

	// do not forget this section
	directives: {
		ClickOutside
	}
}
</script>